import { TextField } from '@/global/components/TextField'
import Grid from '@/global/components/ui/Grid'
import { Label } from '@/global/components/ui/label'
import { cn } from '@/lib/utils'
import type { Dayjs } from 'dayjs'
import Dialog from 'global/guides/Dialog'
import type { TabelaHorarioFuncionario } from 'service/api'
import { horarioDoDia } from '../../horario-do-dia'

interface Props {
    aberto: { tabela: TabelaHorarioFuncionario; dia: Dayjs } | null
    onClose: () => void
}

/** Horários da semana da tabela, só leitura, com o dia clicado em destaque. */
export function HorarioDoDia({ aberto, onClose }: Props) {
    // a semana do dia clicado, de domingo a sábado, como na grade do calendário
    const semana = aberto
        ? Array.from({ length: 7 }, (_, diaSemana) => {
              const dia = aberto.dia.day(diaSemana)
              return {
                  dia,
                  isSelecionado: diaSemana === aberto.dia.day(),
                  ...horarioDoDia(aberto.tabela.TabelaHorario, dia),
              }
          })
        : []

    return (
        <Dialog.Root open={!!aberto} onClose={onClose} width="xl">
            <Dialog.Title action="Horários da semana">
                {aberto?.tabela.TabelaHorario.nome}
            </Dialog.Title>
            <Dialog.Content className="flex flex-col gap-1">
                {semana.map(({ dia, isSelecionado, turnos, total }) => (
                    <div
                        key={dia.day()}
                        className={cn(
                            'px-2 pt-2',
                            isSelecionado &&
                                'bg-card shadow-md border rounded-md',
                        )}
                    >
                        <Label className="mb-2 inline-flex">
                            {isSelecionado && (
                                <div className="rounded-full bg-primary size-3" />
                            )}
                            {dia
                                .format('dddd')
                                .replace(/^[a-z]/, w => w.toUpperCase())}
                        </Label>
                        <Grid container>
                            {turnos.map(({ entrada, saida }, index) => [
                                <Grid
                                    item
                                    xs={6}
                                    sm={2}
                                    key={`entrada-${index}`}
                                >
                                    <TextField
                                        label="Entrada"
                                        variant="outlined"
                                        value={entrada}
                                        readOnly
                                    />
                                </Grid>,
                                <Grid item xs={6} sm={2} key={`saida-${index}`}>
                                    <TextField
                                        label="Saída"
                                        variant="outlined"
                                        value={saida}
                                        readOnly
                                    />
                                </Grid>,
                            ])}
                            <Grid item xs={12} sm={2} className="sm:ml-auto">
                                <TextField
                                    label="Total"
                                    variant="filled"
                                    value={total}
                                    readOnly
                                />
                            </Grid>
                        </Grid>
                    </div>
                ))}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
